import React, { useEffect, useState } from 'react';

const CONSENT_KEY = 'idemgo_cookie_consent';
const POSTHOG_KEY = 'phc_xAvL2Iq4tFmANRE7kzbKwaSqp1HJjN7x48s3vr0CMjs';
const POSTHOG_HOST = 'https://us.i.posthog.com';

function readConsent() {
  try {
    return localStorage.getItem(CONSENT_KEY);
  } catch {
    return null;
  }
}

function saveConsent(value) {
  try {
    localStorage.setItem(CONSENT_KEY, value);
  } catch {
    // If storage is unavailable, keep PostHog disabled for this session.
  }
}

function initializePostHog() {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  if (window.__idemgoPostHogInitialized) return;
  window.__idemgoPostHogInitialized = true;

  !(function (t, e) {
    var o, n, p, r;
    e.__SV ||
      ((window.posthog = e),
      (e._i = []),
      (e.init = function (i, s, a) {
        function g(t, e) {
          var o = e.split('.');
          2 === o.length && ((t = t[o[0]]), (e = o[1]));
          t[e] = function () {
            t.push([e].concat(Array.prototype.slice.call(arguments, 0)));
          };
        }
        p = t.createElement('script');
        p.type = 'text/javascript';
        p.crossOrigin = 'anonymous';
        p.async = true;
        p.src = s.api_host.replace('.i.posthog.com', '-assets.i.posthog.com') + '/static/array.js';
        r = t.getElementsByTagName('script')[0];
        r.parentNode.insertBefore(p, r);
        var u = e;
        if (a !== undefined) {
          u = e[a] = [];
        } else {
          a = 'posthog';
        }
        u.people = u.people || [];
        u.toString = function (t) {
          var e = 'posthog';
          if (a !== 'posthog') e += '.' + a;
          if (!t) e += ' (stub)';
          return e;
        };
        u.people.toString = function () {
          return u.toString(1) + '.people (stub)';
        };
        o = 'init capture identify reset opt_in_capturing opt_out_capturing has_opted_in_capturing has_opted_out_capturing register register_once unregister set_config startSessionRecording stopSessionRecording'.split(' ');
        for (n = 0; n < o.length; n++) g(u, o[n]);
        e._i.push([i, s, a]);
      }),
      (e.__SV = 1));
  })(document, window.posthog || []);

  window.posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    person_profiles: 'identified_only',
    disable_session_recording: true,
    capture_pageview: false,
    autocapture: false,
  });
}

export default function CookieConsentBanner() {
  const [consent, setConsent] = useState(readConsent);

  useEffect(() => {
    if (consent === 'accepted') initializePostHog();
  }, [consent]);

  const choose = (value) => {
    saveConsent(value);
    setConsent(value);
  };

  if (consent === 'accepted' || consent === 'rejected') return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-[60] border-t border-zinc-200 bg-white">
      <div className="mx-auto flex max-w-[1200px] flex-col gap-4 px-6 py-4 md:flex-row md:items-center md:justify-between">
        <p className="max-w-2xl text-sm leading-relaxed text-zinc-600">
          We use optional analytics to improve idemGO and understand which features are useful. Analytics only runs if you accept. Sensitive verification data is excluded from analytics tracking.
        </p>
        <div className="flex shrink-0 flex-wrap items-center gap-2">
          <button
            type="button"
            onClick={() => choose('rejected')}
            className="border border-zinc-200 px-3 py-2 text-sm font-medium text-zinc-700 hover:border-zinc-400"
          >
            Reject analytics
          </button>
          <button
            type="button"
            onClick={() => choose('accepted')}
            className="border border-black bg-black px-3 py-2 text-sm font-medium text-white hover:bg-zinc-800"
          >
            Accept analytics
          </button>
        </div>
      </div>
    </div>
  );
}
